import {
    overquotaNewFullBlocked,
    overquotaNewFullBlockedModal,
} from 'reactApp/appHelpers/featuresHelpers/features/overquotaNewFullBlocked';
import { overquotaUseQuotaForProfileApi } from 'reactApp/appHelpers/featuresHelpers/features/overquotaUseProfileApiAndQuota';
import {
    overStatesCheckedByQuota,
    overStatesCheckedByQuotaNew,
} from 'reactApp/appHelpers/featuresHelpers/features/overStatesCheckedByQuota';
import { getUserOverquotaState } from 'reactApp/modules/profile/profile.selectors';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { UserQuotaSelectors } from 'reactApp/modules/userQuota/userQuota.selectors';
import type { RootState } from 'reactApp/store';
import { createSelector } from 'reselect';
import type { QuotaStates } from 'server/types/context/IUser';

const backOverquotaStates: QuotaStates[] = ['started', 'blocked', 'unblocked', 'cleared', 'after_clear'];

if (overquotaNewFullBlocked || overquotaNewFullBlockedModal) {
    backOverquotaStates.push('full_blocked');
}

export const getOverquotaFromProfileApi = (state: QuotaStates | undefined, isOverQuota: boolean) => {
    let isOverquotaFromProfileApi = state ? backOverquotaStates.includes(state) : false;
    if (isOverquotaFromProfileApi && state && overStatesCheckedByQuota.includes(state) && overquotaUseQuotaForProfileApi && !isOverQuota) {
        // Юзер не в оверквоте, но бек скорее всего еще не обработал состояние после удаления файлов юзером
        isOverquotaFromProfileApi = false;
    }
    return isOverquotaFromProfileApi;
};

export const isUserOverquotaFromApi = createSelector(UserQuotaSelectors.isOverquota, getUserOverquotaState, (isOverquota, quotaState) => {
    return getOverquotaFromProfileApi(quotaState?.state, isOverquota);
});

const backOverquotaStatesNew: QuotaStates[] = [...backOverquotaStates, 'full_blocked'];

// Новый флоу определения оверквотера (выкидываем учет фичи overquotaNewFullBlocked. Просто выкинуть пока не можем)
// Используйте, если нужно также учитывать стейт full_blocked без фичи overquotaNewFullBlocked
export const isUserOverquotaAndFromApiNew = createSelector(
    UserQuotaSelectors.isOverquota,
    getUserOverquotaState,
    (isOverquota, quotaState) => {
        let isOverquotaFromProfileApi = quotaState?.state ? backOverquotaStatesNew.includes(quotaState?.state) : false;
        if (
            isOverquotaFromProfileApi &&
            quotaState?.state &&
            overStatesCheckedByQuotaNew.includes(quotaState?.state) &&
            overquotaUseQuotaForProfileApi &&
            !isOverquota
        ) {
            // Юзер не в оверквоте, но бек скорее всего еще не обработал состояние после удаления файлов юзером
            isOverquotaFromProfileApi = false;
        }
        return isOverquotaFromProfileApi;
    }
);

export const isCloudOrMailOrApiOverQuota = createSelector(
    [
        (state: RootState) => UserSelectors.isOverQuotaUser(state), // только Облачная оверквота на основе инфы о квоте из SSR
        (state: RootState) => isUserOverquotaAndFromApiNew(state), // апишная оверквота с даблчеком по UserQuotaSelectors.isOverquota (т.е. по ответу user/quota)
        (state: RootState) => UserQuotaSelectors.isOverquota(state), // единая оверквота по ручке UserQuotaSelectors.isOverquota (получается триплчек))
    ],
    (isOverQuotaCloud, isOverquotaFromProfileApi, isOverQuotaMailAndCloud) =>
        isOverQuotaCloud || isOverquotaFromProfileApi || isOverQuotaMailAndCloud
);
